import { useState } from "react";
import axios from "axios";
import { composeApiURL } from "helpers/utility/axiosHelpers";

export const useDeleteSeedAssignment = () => {
  const [loading, setLoading] = useState(false);

  const deleteAssignment = async ({
    datasetId,
    seedId,
    labelCategoryId,
  }: {
    datasetId: string;
    seedId: string;
    labelCategoryId: string;
  }) => {
    setLoading(true);
    try {
      const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;
      const url = composeApiURL(
        HOST_URL,
        `/flywheel/${datasetId}/seed/${seedId}/${labelCategoryId}`,
      );
      await axios.delete(url);
    } catch (e) {
      throw e;
    } finally {
      setLoading(false);
    }
  };

  const deleteSingleItemFromAssignment = async ({
    datasetId,
    seedId,
    labelCategoryId,
    mediaId,
  }: {
    datasetId: string;
    seedId: string;
    labelCategoryId: string;
    mediaId: string;
  }) => {
    setLoading(true);

    try {
      const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;
      const url = composeApiURL(
        HOST_URL,
        `/flywheel/${datasetId}/seed/${seedId}/${labelCategoryId}/${mediaId}`,
      );
      await axios.delete(url);
    } catch (e) {
      throw e;
    } finally {
      setLoading(false);
    }
  };

  return {
    deleteAssignment,
    deleteSingleItemFromAssignment,
    loading,
  };
};
